import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Message } from '@model';
import { environment } from 'environments/environment';
import { SxErrorService } from 'app/services/sx-error.service';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {
  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  getMyMessages(): Observable<Message[]> {
    return this.http
      .get<Message[]>(`${environment.apiEndpoint}/Messages`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  getMyUnreadMessagesCount(): Observable<number> {
    return this.http
      .get<number>(`${environment.apiEndpoint}/Messages/Unread/Count`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  setMessageAsRead(message: Message): Observable<Message> {
    return this.http
      .post<Message>(`${environment.apiEndpoint}/Messages/Unread/${message.id}/read`, null)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }
}
